

const filterGetItemsGroupBy = () => ([[{
  id: 'by_complexes',
  title: 'комплектам',
}, {
  id: 'by_klasses',
  title: 'классам',
}], ['by_complexes']])

export default filterGetItemsGroupBy
